// File: src/views/Solution.js

import React from 'react';
import styles from './Solution.module.css';
import VideoShowcase from '../components/solution/VideoShowcase';
import SolutionInfographic from '../components/solution/SolutionInfographic';

function Solution() {
  return (
    <div className={styles.page}>
      <VideoShowcase />
      <SolutionInfographic />
    </div>
  );
}

export default Solution;